<template>
    <div>
        <div class="home">
            <div class="box">
                <van-button type="info" class="btn" @click="goEnterprise">单位</van-button>
                <van-button type="info" class="btn" @click="goProject">项目</van-button>
                <van-button type="info" class="btn" @click="goFacility">设备</van-button>
                <van-button type="info" class="btn" @click="goDetection">检验检测</van-button>
                <!-- <van-button type="info" @click="GoPublishHome" class="btn">复检发布</van-button> -->
            </div>
            <div class="box_w">
                <van-button type="warning" @click="MaintenanceHomePage" class="btn">检查维保</van-button>
                <van-button type="warning" @click="Maintenance" class="btn">日报日检</van-button>
                <van-button type="warning" @click="InstallationHomePage" class="btn">安装验收</van-button>
                <van-button type="warning" @click="SiteHomePage" class="btn">进场验收</van-button>
            </div>
            <div class="box_w">
                <van-button type="danger" @click="RootPage" class="btn">权限配置</van-button>
                <van-button type="danger" @click="ustomsInspection" class="btn">报检服务</van-button>
                <van-button type="danger" @click="evaluateServe" class="btn">评价服务</van-button>
                <van-button type="danger" @click="patrolHome" class="btn">巡检服务</van-button>
            </div>
            <div class="box_w">
                <van-button type="danger" @click="evaHome" class="btn">评价</van-button>
                <van-button type="info" class="btn" @click="inspection">检验检测2</van-button>
            </div>

            <div class="box_w">
                <van-button type="danger" @click="evaHome" class="btn">评价</van-button>
                <van-button type="info" class="btn" @click="inspection">检验检测2</van-button>
            </div>

            <div class="box_w">
                <van-button type="danger" @click="phySealApply" class="btn">印章申请</van-button>
                <van-button type="primary" @click="goPermissionManagement" class="btn">权限管理</van-button>
            </div>

            <div class="box_w">
                <van-button type="danger" @click="workTask" class="btn">工作任务</van-button>
                <van-button type="primary" @click="scan" class="btn">扫码模拟</van-button>
            </div>
        </div>
    </div>

</template>

<script type="text/javascript">
export default {
    name: 'Home',
    data() {
        return {
            name: '设备',
            val: '',
            token: '',
            imgRef: '',
        }
    },
    methods: {
        scan() {
            this.$router.push({
                path: '/scanpdf',
                query: {
                    msg: JSON.stringify({
                        exportId: '175295',
                        flowId: 'JYC-241217029KSXXF',
                        module: 'inspection_detection'
                    })
                }
            })
        },
        inspection() {
            this.$router.push({
                path: '/inspectionHomePage',
            })
        },
        evaHome() {
            this.$router.push({
                path: '/evaHome',
            })
        },
        patrolHome() {
            this.$router.push({
                path: '/patrolHome',
            })
        },
        inspectHomePage() {
            this.$router.push({
                path: '/inspectHomePage',
            })
        },
        evaluateServe() {
            this.$router.push({
                path: '/evaluateServeHome',
            })
        },
        ustomsInspection() {
            this.$router.push({
                path: '/UstomsInspection',
            })
        },
        RootPage() {
            this.$router.push({
                path: '/RootPage',
            })
        },
        Maintenance() {
            this.$router.push({
                path: '/DailycheckHomePage',
            })
        },
        InstallationHomePage() {
            this.$router.push({
                path: '/InstallationHomePage',
            })
        },
        MaintenanceHomePage() {
            this.$router.replace({
                path: '/MaintenanceHomePage',
            })
        },
        GoPublishHome() {
            this.$router.replace({
                path: '/PublishHome',
            })
        },
        SiteHomePage() {
            this.$router.replace({
                path: '/SiteHomePage',
            })
        },
        goname() {
            this.$router.replace({
                path: '/signature',
            })
        },
        // 跳转单位
        goEnterprise() {
            this.$router.replace({
                path: '/Enterprise',
            })
        },
        // 跳转项目
        goProject() {
            this.$router.replace({
                path: '/article',
            })
        },
        // 跳转设备
        goFacility() {
            this.$router.replace({
                path: '/facility',
            })
        },
        // 跳转检验检测
        goDetection() {
            this.$router.replace({
                path: '/detection',
            })
        },
        goInstrument() {
            this.$router.replace({
                path: '/instrument',
            })
        },
        goRecordDetailsOnly() {
            this.$router.replace({
                path: '/RecordDetailsOnly',
            })
        },
        phySealApply() {
            this.$router.replace({
                path: '/sealApply',
            })
        },
        workTask() {
            this.$router.replace({
                path: '/workTask',
            })
        },
        goPermissionManagement() {
            this.$router.push({
                path: '/PermissionManagement',
            })
        },
    },
    mounted() { },
    created() {
        this.imgRef = this.$route.query.imgRef
    },
    components: {},
}
</script>

<style>
.home {
    margin: 2.5rem auto;
    display: flex;
    flex-wrap: wrap;
}

.box {
    width: 100%;
    height: 3.75rem;
    /* background-color:red; */
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.box_w {
    width: 100%;
    height: 3.75rem;
    /* background-color:rgb(64, 32, 204); */
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
</style>
